import { ProductType } from '@energy-retailer/constants';
import Link from 'next/link';

import { Text } from '../text';

type ProductPlanDescriptionProps = {
  description?: string;
  termsLink?: string;
  fairUseLink?: string;
  productType: ProductType;
};

const ProductPlanCardDescription = ({
  description,
  termsLink,
  fairUseLink,
  productType,
}: ProductPlanDescriptionProps) => {
  if (fairUseLink && termsLink && productType === ProductType.EvDaySaver) {
    return (
      <div>
        <Text
          variant="body3"
          weight="normal"
        >
          Offer is available to new residential customers who switch to Powershop or are moving premises, and is subject to our other eligibility criteria,{' '}
          <Link
            href={termsLink}
            target="_blank"
            rel="noopener"
            className="!text-base"
          >
            offer terms
          </Link>{' '}
          and{' '}
          <Link
            href={fairUseLink}
            target="_blank"
            rel="noopener"
            className="!text-base"
          >
            Fair Use Policy.
          </Link>
        </Text>
      </div>
    );
  }

  return (
    <div>
      <Text
        variant="body3"
        weight="normal"
      >
        {description}
        {termsLink ? (
          <Link
            href={termsLink}
            target="_blank"
            rel="noopener"
            className="!text-base"
          >
            {productType !== ProductType.EvNightSaver ? `T&Cs apply` : `T&Cs.`}
          </Link>
        ) : (
          ''
        )}
      </Text>
    </div>
  );
};

export { ProductPlanCardDescription };
